import React from 'react';

export default function AdminPreviewBanner() {
  const commit = typeof __ADMIN_PREVIEW_SHA__ === 'string' ? __ADMIN_PREVIEW_SHA__ : '';
  if (!/^[0-9a-f]{40}$/.test(commit)) return null;
  return (
    <div role="note" style={{ position: 'fixed', bottom: 0, right: 0, zIndex: 2000,
      background: '#18344e', color: '#fff', padding: '5px 12px', fontSize: 12 }}>
      Dev admin preview · {commit.slice(0, 8)} · Runtime-gated controls
    </div>
  );
}
